import { Button } from "@/components/ui/button";
import { Trash2, Pencil } from "lucide-react";
import { format } from "date-fns";
import { EditContentDialog } from "@/components/EditContentDialog";
import { useState } from "react";
import { convertStoredToDisplayFormat } from "@/lib/contentFormatting";

interface SavedDraftsTabProps {
  drafts: Array<{
    id: string;
    content: string;
    created_at: string;
    images?: string[];
    video?: string;
  }>;
  onDeleteDraft: (id: string) => void;
  onDraftUpdated: () => void;
}

export const SavedDraftsTab = ({
  drafts,
  onDeleteDraft,
  onDraftUpdated,
}: SavedDraftsTabProps) => {
  const [editingDraft, setEditingDraft] = useState<{
    id: string;
    content: string;
    images?: string[];
    video?: string;
  } | null>(null);

  return (
    <>
      {drafts.length > 0 ? (
        <div className="space-y-3">
          {drafts.map((draft) => (
            <div 
              key={draft.id} 
              className="bg-card p-4 rounded-lg border shadow-sm hover:border-primary/50 transition-colors"
            >
              <div className="space-y-3">
                <p className="text-sm text-muted-foreground">
                  Created: {format(new Date(draft.created_at), "MMMM do, yyyy 'at' h:mm a")}
                </p>
                <div 
                  className="prose prose-sm max-w-none text-sm whitespace-pre-wrap"
                  dangerouslySetInnerHTML={{ 
                    __html: convertStoredToDisplayFormat(draft.content)
                  }} 
                />
                <div className="flex justify-end gap-2">
                  <Button 
                    variant="outline"
                    size="icon"
                    onClick={() => setEditingDraft({
                      id: draft.id,
                      content: draft.content,
                      images: draft.images,
                      video: draft.video
                    })}
                  >
                    <Pencil className="h-4 w-4" />
                  </Button>
                  <Button 
                    variant="outline"
                    size="icon"
                    onClick={() => onDeleteDraft(draft.id)}
                  >
                    <Trash2 className="h-4 w-4 text-destructive" />
                  </Button>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="text-center py-8 text-muted-foreground">
          No saved drafts yet
        </div>
      )}

      <EditContentDialog
        open={!!editingDraft}
        onOpenChange={(open) => !open && setEditingDraft(null)}
        initialContent={editingDraft?.content || ""}
        contentType="draft"
        itemId={editingDraft?.id || ""}
        onContentUpdated={onDraftUpdated}
        images={editingDraft?.images || []}
        video={editingDraft?.video || null}
      />
    </>
  );
};